(() => {
  const searchModal = qs('#js-search-modal');
  const searchPredictive = qs('#js-search-modal-predictive');
  const searchPopular = qs('#js-search-modal-popular');
  const searchInput = qsa('.js-search-modal-input');
  const searchModalOpen = qs('.js-search-modal-button-open');
  const searchModalClose = qsa('.js-search-modal-button-close, .js-search-modal-overlay');
  const searchFormFocus = 'search-modal__form--focus';
  const searchModalActive = 'search-modal--active';

  if(searchModal) {
    searchModalOpen && searchModalOpen.addEventListener('click', (e) => {
      e.preventDefault();
      searchModal.classList.add(searchModalActive);
      scrollLock();
    })
    
    searchModalClose.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        searchModal.classList.remove(searchModalActive);

        if(searchPredictive) searchPredictive.style.display = 'none';
        if(searchPopular) searchPopular.removeAttribute('style');

        searchInput.forEach(input => {
          if(input.value) {
            getClosest('.js-search-modal-form', input).classList.remove('search-modal__form--focus');
            input.value = '';
          }
        })

        scrollLock(false);
      })
    });

    if(searchInput) {
      searchInput.forEach(input => {
        if(input.value) {
          getClosest('.js-search-modal-form', input).classList.add(searchFormFocus);
        }
        
        input.addEventListener('focus', (e) => {
          e.preventDefault();
          getClosest('.js-search-modal-form', e.currentTarget).classList.add(searchFormFocus);
        })

        input.addEventListener('blur', (e) => {
          e.preventDefault();
          const current = e.currentTarget;
          const form = getClosest('.js-search-modal-form', current);

          if(current.value) {
            form.classList.add(searchFormFocus);
          } else {
            form.classList.remove(searchFormFocus);
          }
        })
      })
    }
  }
})();